import { gsap } from 'gsap';

export default class Nav {
  constructor(navRoot) {
    this.navRoot = navRoot;
    this.navMain = this.navRoot.querySelector('.js-nav-main');
    this.navButtons = Array.from(this.navRoot.querySelectorAll('.js-nav-btn'));
    this.body = document.body;

    this.isAnimating = false;
    this.isOpen = false;

    this.init();
  }

  init() {
    this.createTimeline();

    this.navButtons.forEach((button) => {
      button.addEventListener('click', () => this.handleNav(button.dataset.action));
    });

    document.addEventListener('keydown', (e) => this.handleKeyDown(e));
  }

  createTimeline() {
    this.tl = gsap.timeline({
      paused: true,
      onComplete: () => {
        this.isAnimating = false;
      },
      onReverseComplete: () => {
        this.navMain.hidden = true;
        this.isAnimating = false;
        this.body.classList.remove('no-scroll');
        document.removeEventListener('touchmove', this.preventScrolling);
      },
      onStart: () => {
        this.navMain.hidden = false;
        this.body.classList.add('no-scroll');

        // prevent background from scrolling on ios devices
        document.addEventListener('touchmove', this.preventScrolling, { passive: false });
      },
    });

    this.tl
      .set('.js-nav-container', {
        opacity: 0,
      })
      .to(this.navMain, {
        duration: 0.5,
        ease: 'power2.InOut',
        x: '0%',
      })
      .to('.js-nav-container', {
        ease: 'none',
        opacity: 1,
      });
  }

  preventScrolling(e) {
    if (e.target.parentElement.closest('.js-scrollable')) return;
    e.preventDefault();
  }

  handleKeyDown({ key }) {
    if (key !== 'Escape' || !this.isOpen) return;

    this.handleNav('close');
  }

  handleNav(action) {
    if (this.isAnimating) return;

    this.isAnimating = true;
    this.isOpen = action === 'open';

    this.navButtons.filter((button) => button.dataset.action === 'open').forEach((button) => button.setAttribute('aria-expanded', this.isOpen));

    this.isOpen ? this.tl.play() : this.tl.reverse();
  }
}
